var map = {
	"./leaderboard_blue.svg": 662,
	"./leaderboard_green.svg": 7935,
	"./leaderboard_grey.svg": 7666,
	"./leaderboard_orange.svg": 3075,
	"./leaderboard_pink.svg": 6191,
	"./leaderboard_purple.svg": 5638,
	"./leaderboard_red.svg": 6896,
	"./leaderboard_turquoise.svg": 5066,
	"./leaderboard_violet.svg": 2139,
	"./leaderboard_yellow.svg": 7067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 821;